import React from "react";

import { connect } from "react-redux";

import { Link, Redirect } from "react-router-dom";
import _ from "lodash";
import logo from "logo.png";
import "./signin.css";

import { addUser } from "store/actions/security";
import API from "api";
import Axios from "axios";

export const FormErrors = ({ formErrors }) => (
  <div className="formErrors">
    {Object.keys(formErrors).map((fieldName, i) => {
      if (formErrors[fieldName].length > 0) {
        return (
          <p key={i}>
            {fieldName} {formErrors[fieldName]}
          </p>
        );
      } else {
        return "";
      }
    })}
  </div>
);
class SignUp extends React.Component {
  state = {
    use: {},
    errors: [],
    message: "",

    error: "",
    submitting: false
  };

  getError(field) {
    let errors = this.state.errors || {};
    let error = errors.children ? errors.children[field] : undefined;
    if (error !== undefined && error.errors && error.errors.length > 0) {
      error = { message: _.join(error.errors, ", ") };
    }

    return _.find(errors, { property_path: field }) || error;
  }
  renderFieldError(field) {
    let error = this.getError(field);
    if (error === undefined) return null;
    return <small className="text-danger">{error.message}</small>;
  }
  register = e => {
    e.preventDefault();
    const user = this.state.user || {};

    if (!user.optin) {
      this.setState({
        error: "Vous devez accepter les conditions général pour vous inscrire"
      });
    } else {
      this.setState({ submitting: true, error: "" });

      API.register(user)
        .then(response => {
          const { message, apiKey } = response.data;
          if (apiKey) {
            API.profile(apiKey).then(res => {
              const user = res.data;

              // login user;
              const expiresAt = new Date();
              user.last_login = new Date();
              expiresAt.setDate(expiresAt.getDate() + 7);
              Axios.defaults.headers.common["Authorization"] = user.api_key;
              user.accessUntil = expiresAt;

              this.setState(
                {
                  error: null,
                  submitting: false
                },
                () => {
                  this.props.addUser(user);
                }
              );
            });
          } else {
            this.setState({ message, error: null, submitting: false });
          }
        })
        .catch(error => {
          let message = error.message;
          let errors = [];

          if (error.response) {
            message = "";
            errors = error.response.data.validationErrors;
          } else {
          }
          this.setState({
            error: message,
            errors,
            submitting: false
          });
        });
    }
  };

  handleInput = e => {
    const name = e.target.name;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    let modelName = e.target.dataset.model || null;

    let model = null;
    if (modelName) {
      model = { ...this.state[modelName] };
    }
    model[name] = value;

    this.setState({ [modelName]: model });
  };

  render() {
    const { submitting, message, error } = this.state;
    if (this.props.isAuth) {
      return (
        <Redirect
          to={{
            pathname: "/publications",
            state: { from: this.props.location }
          }}
        />
      );
    }
    return (
      <div className=" min-vh-100 d-flex  justify-content-center align-items-center">
        <div className="wrapper fadeInDown">
          <Link to="/publications">
            <img src={logo} alt="logo" className="mb-4" height="100" />
          </Link>
          <div className="formContent">
            <div className="fadeIn first">
              {/* <img
                src="http://danielzawadzki.com/codepen/01/icon.svg"
                id="icon"
                alt="User Icon"
              /> */}
            </div>

            <form
              method="post"
              className="my-3 d-flex flex-column align-items-center px-4"
            >
              {error && <p className="text-danger text-center">{error}</p>}
              {message && <p className="text-success text-center">{message}</p>}

              <input
                type="text"
                className="fadeIn second"
                name="lastName"
                placeholder="Nom"
                data-model="user"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("firstName")}
              <input
                type="text"
                className="fadeIn second"
                name="firstName"
                data-model="user"
                placeholder="Prénom"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("lastName")}

              <input
                type="text"
                className="fadeIn second"
                name="email"
                data-model="user"
                placeholder="Email"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("email")}

              <input
                type="password"
                className="fadeIn second"
                name="password"
                data-model="user"
                placeholder="Mot de passe"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("plainPassword")}

              <div>
                <label className="text-dark">
                  <input
                    type="checkbox"
                    data-model="user"
                    name="optin"
                    value="optin"
                    disabled={submitting}
                    onChange={this.handleInput}
                  />
                  J'accepte les mentions légales
                </label>
              </div>
              <div>
                <a
                  href="https://cgu.kioskpress.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {"Mentions légales"}
                </a>
              </div>
              <button
                type="button"
                disabled={submitting}
                className="btn btn-ikea btn-block my-4 fadeIn fourth"
                onClick={this.register}
              >
                Inscription
              </button>
            </form>
            <div className="formFooter d-flex justify-content-between">
              <Link to="/signin" className="underlineHover">
                Connexion
              </Link>
              <Link to="/publications" className="underlineHover">
                Retour aux titres
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({
  addUser: user => dispatch(addUser(user))
});
export default connect(mapStateToProps, binActionsToProps)(SignUp);
